<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>交易管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'tradeInquire' }">交易查询</el-breadcrumb-item>
        <el-breadcrumb-item>交易订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--商品详情列表-->
    <div class="hx-form-container box-shadow">
      <el-table v-loading="orderTableLoading" show-summary :summary-method="getSummaries" :data="orderTableData">
        <el-table-column align="center" prop="title" label="商品名称">
          <template slot-scope="scope">
            <div class="commodity-name-style">
              <div class="commodity-wrap-img-style">
                <img :src="scope.row.coverImage" alt="" class="commodity-img-style" />
                <span>{{ scope.row.title }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="productPrice" label="商品价格">
          <template slot-scope="scope">
            <span>{{ scope.row.productPrice | formatToFixed2("元") }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="productSpec" label="商品规格"> </el-table-column>

        <el-table-column align="center" prop="quantity" label="商品数量"> </el-table-column>

        <el-table-column align="center" prop="paymentAmount" label="商品定金">
          <template slot-scope="scope">
            <span>{{ scope.row.paymentAmount | formatToFixed2("元") }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="levelDiscountAmount" label="级别折扣金额">
          <template slot-scope="scope">
            <span>{{ scope.row.levelDiscountAmount | formatToFixed2("元") }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="orderAmount" label="商品总价">
          <template slot-scope="scope">
            <span>{{ scope.row.orderAmount | formatToFixed2("元") }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--订单信息-->
    <div class="hx-form-container box-shadow">
      <p class="form-title">订单信息</p>
      <div class="form-details">
        <el-form :model="orderInfoForm">
          <el-row :gutter="24">
            <el-col :span="10">
              <el-form-item label="订单编号：">
                {{ orderInfoForm.orderNo }}
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="下单日期：">
                {{ orderInfoForm.paymentDate | formatDate(true) }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="10">
              <el-form-item label="订单状态：">
                {{ orderInfoForm.orderStatusDisplay }}
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="支付状态：">
                {{ orderInfoForm.paymentStatus }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="10">
              <el-form-item label="商品总金额：">
                {{ orderInfoForm.orderAmount | formatToFixed2 }}
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="订单定金：">
                {{ orderInfoForm.paymentAmount | formatToFixed2 }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="10">
              <el-form-item label="定金支付方式：">
                {{ orderInfoForm.paymentType }}
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="保障级别名称：">
                {{ orderInfoForm.levelName }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="10">
              <el-form-item label="级别折扣："> {{ orderInfoForm.levelDiscountRate }}折 </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="总折扣金额：">
                {{ orderInfoForm.totalDiscountAmount | formatToFixed2 }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <!--收货信息-->
    <div class="hx-form-container box-shadow">
      <p class="form-title">收货信息</p>
      <div class="form-details">
        <el-form :model="receivingInfoForm">
          <el-row :gutter="24">
            <el-col :span="7">
              <el-form-item label="收货人手机号码：">
                {{ receivingInfoForm.buyerMobile }}
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="收货地址：">
                {{ receivingInfoForm.logisticsSiteName }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <!--核销结果列表-->
    <div class="hx-form-container box-shadow">
      <p class="form-title">
        <span>核销列表</span>
        <span style="float: right; font-size: 16px">注：当前页面订单在列表中已标红</span>
      </p>
      <el-table v-loading="cancelTableLoading" style="margin-top: 20px" :data="cancelTableData" border>
        <el-table-column align="center" label="商品" prop="productTitle">
          <template slot-scope="{ row }">
            <img :src="row.productPicture" style="width: 100px; height: 100px" alt="" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="商品名称" prop="productTitle" />
        <el-table-column align="center" label="商品规格" prop="productSpec">
          <template slot-scope="{ row }"> {{ row.productSpecWeight }}/{{ row.productSpec }} </template>
        </el-table-column>
        <el-table-column align="center" label="商品数量" prop="productQuantity" />
        <el-table-column align="center" label="商品单价" prop="productPrice" />
        <el-table-column align="center" label="折扣率" prop="levelDiscountRate" />
        <el-table-column align="center" label="核销金额" prop="tradeAmount" />
        <el-table-column align="center" label="核销退款状态" prop="showStatus">
          <template slot-scope="{ row }">
            {{ status[row.showStatus] }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="退款/补差" prop="fillOrRefundAmount" />
        <el-table-column align="center" label="折扣后单价" prop="discountPrice" />
      </el-table>
    </div>

    <!-- 退款列表 -->
    <div class="hx-form-container box-shadow">
      <p class="form-title">
        <span>退款列表</span>
      </p>
      <el-table style="margin-top: 20px" :data="refundTableData" border>
        <!-- <el-table-column align="center" label="商品名称" prop="reason" />
        <el-table-column align="center" label="商品退货份数" prop="reason" /> -->
        <el-table-column align="center" label="退款类型" prop="refundType">
          <template slot-scope="scope">
            <span>{{ scope.row.refundType | formatRefundType }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="退款原因" prop="reason" />

        <el-table-column align="center" label="退款金额" prop="refundAmount" />

        <el-table-column align="center" label="退款状态" prop="refundStatus">
          <template slot-scope="scope">
            <span v-if="scope.row.refundStatus === 20" class="success">
              {{ scope.row.refundStatus | formatRefundStatus }}
            </span>
            <span v-else-if="scope.row.refundStatus === 30" class="fail">
              {{ scope.row.refundStatus | formatRefundStatus }}
            </span>
            <span v-else>
              {{ scope.row.refundStatus | formatRefundStatus }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="退款补充原因" prop="refundAmount" /> -->

        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewRefundDetail(scope.row.refundId)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 退款详情弹窗 -->
    <el-dialog title="退款详情" :visible.sync="refundDetailDialogVisible" width="650px" top="15vh">
      <div v-loading="refundDetailLoading">
        <div v-if="refundDetailData">
          <el-form label-width="130px" size="small">
            <el-form-item label="退款记录ID：">{{ refundDetailData.refundId }}</el-form-item>
            <el-form-item label="退款金额：">{{ refundDetailData.refundAmount }}元</el-form-item>
            <el-form-item label="退款类型：">{{ refundDetailData.refundType | formatRefundType }}</el-form-item>
            <el-form-item label="退款状态：">
              <span v-if="refundDetailData.refundStatus === 20" class="success">{{ refundDetailData.refundStatus | formatRefundStatus }}</span>
              <span v-else-if="refundDetailData.refundStatus === 30" class="fail">{{ refundDetailData.refundStatus | formatRefundStatus }}</span>
              <span v-else>{{ refundDetailData.refundStatus | formatRefundStatus }}</span>
            </el-form-item>
            <el-form-item label="退款原因：">{{ refundDetailData.reason }}</el-form-item>
            <el-form-item label="创建时间：">{{ refundDetailData.createdTime }}</el-form-item>
            <el-form-item label="支付渠道：">{{ refundDetailData.paymentChannel }}</el-form-item>

            <template v-if="refundDetailData.hasWechatResult">
              <el-divider content-position="left">微信退款查询结果</el-divider>
              <el-form-item label="微信交易号：">{{ refundDetailData.wechatTransactionId }}</el-form-item>
              <el-form-item label="退款金额(分)：">{{ refundDetailData.wechatRefundFee }}</el-form-item>
              <el-form-item label="订单总金额(分)：">{{ refundDetailData.wechatTotalFee }}</el-form-item>
              <el-form-item label="退款笔数：">{{ refundDetailData.wechatRefundCount }}</el-form-item>
              <el-form-item label="退款入账账户：">{{ refundDetailData.wechatRefundRecvAccout }}</el-form-item>
              <el-form-item label="退款成功时间：">{{ refundDetailData.wechatRefundSuccessTime }}</el-form-item>
            </template>
            <template v-else>
              <el-divider content-position="left">微信退款查询结果</el-divider>
              <p class="fail" style="padding-left: 130px">{{ refundDetailData.message || '未获取到微信退款详情' }}</p>
            </template>
          </el-form>
        </div>
        <div v-else class="fail">暂无退款详情数据</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { featchRecord, fetchRefundWechatDetail } from "./api";
export default {
  data() {
    return {
      orderId: "",
      orderTableData: [],
      orderTableLoading: false,
      orderInfoForm: {
        orderNo: "",
        paymentDate: "",
        orderStatusDisplay: "",
        paymentStatus: "",
        orderAmount: "",
        paymentAmount: "",
        paymentType: "",
        levelName: "",
        levelDiscountRate: "",
        totalDiscountAmount: 0,
      },
      receivingInfoForm: {
        buyerMobile: "",
        logisticsSiteName: "",
      },
      cancelTableData: [],
      cancelTableLoading: false,
      refundTableData: [],
      // 退款详情弹窗
      refundDetailDialogVisible: false,
      refundDetailLoading: false,
      refundDetailData: null,
      status: {
        1: "撤销",
        2: "正常",
        3: "部分退款",
      },
    };
  },

  filters: {
    formatRefundType(value) {
      switch (value) {
        case 10:
          return "取消订单";
        case 20:
          return "退货退款";
        case 30:
          return "重复支付";
        case 40:
          return "核销退款";
      }
    },
    formatRefundStatus(value) {
      switch (value) {
        case 10:
          return "退款中";
        case 20:
          return "退款成功";
        case 30:
          return "退款失败";
      }
    },
  },

  mounted() {
    this.loadDetailData();
    this.fetchRecord();
  },

  methods: {
    /**
     * 核销记录
     */
    fetchRecord() {
      //  this.$route.query.id
      featchRecord(this, { orderId: this.$route.query.id }).then(res => {
        this.cancelTableData = res;
      });
    },
    /**
     * 加载详情页数据
     */
    loadDetailData() {
      const orderId = this.$route.query.id;
      if (orderId) {
        this.orderTableLoading = true;
        this.cancelTableLoading = true;
        this.$http({
          url: global.apiUrl + "/order/detail?orderId=" + orderId,
          method: "GET",
        })
          .then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              const dataList = res.body.data;
              this.orderId = dataList.orderId;
              this.orderTableData = dataList.goodsList;
              this.orderTableLoading = false;
              this.orderInfoForm.orderNo = dataList.orderNo;
              this.orderInfoForm.paymentDate = dataList.paymentDate;
              this.orderInfoForm.orderStatusDisplay = dataList.orderStatusDisplay;
              this.orderInfoForm.paymentStatus = dataList.paymentStatus;
              this.orderInfoForm.orderAmount = dataList.orderAmount;
              this.orderInfoForm.paymentAmount = dataList.paymentAmount;
              this.orderInfoForm.paymentType = dataList.paymentType;

              this.orderInfoForm.levelName = dataList.levelName;
              this.orderInfoForm.levelDiscountRate = dataList.levelDiscountRate;
              this.orderInfoForm.totalDiscountAmount = dataList.totalDiscountAmount;

              this.receivingInfoForm.buyerMobile = dataList.buyerMobile;
              this.receivingInfoForm.logisticsSiteName = dataList.logisticsSiteName;
              this.cancelTableLoading = false;
              this.refundTableData = dataList.refundDetailDtoList;
            } else {
              this.orderTableLoading = false;
              this.cancelTableLoading = false;
            }
          })
          .catch(err => {
            this.orderTableLoading = false;
            this.cancelTableLoading = false;

            console.error(err);
          });
      }
    },
    /**
     * 查看退款详情
     */
    viewRefundDetail(refundId) {
      if (!refundId) {
        this.$message.warning("退款记录ID为空");
        return;
      }
      this.refundDetailDialogVisible = true;
      this.refundDetailLoading = true;
      this.refundDetailData = null;
      fetchRefundWechatDetail(this, { refundId: refundId }).then(res => {
        this.refundDetailData = res;
        this.refundDetailLoading = false;
      }).catch(err => {
        console.error("查询退款详情失败", err);
        this.refundDetailLoading = false;
        this.$message.error("查询退款详情失败");
      });
    },
    /**
     * 获取合计数据
     * @param params
     * @returns {Array}
     */
    getSummaries(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property !== "productPrice") {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            if (column.property !== "quantity") {
              sums[index] = sums[index].toFixed(2) + "元";
            }
          } else {
            sums[index] = "";
          }
        }
      });
      return sums;
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .hx-form-container {
    .commodity-name-style {
      width: 100%;
      height: 50px;
      .commodity-wrap-img-style {
        width: 250px;
        height: 50px;
        overflow: hidden;
        position: relative;
        margin-left: 30px;
        .commodity-img-style {
          position: absolute;
          top: 0;
          left: 0;
          width: 50px;
          height: 100%;
        }
      }
      span {
        line-height: 50px;
      }
    }
    .form-title {
      font-size: 18px;
      font-weight: 600;
      padding-left: 10px;
    }
    .form-details {
      padding: 10px 20px;
    }
  }
  .orderColor {
    color: red;
  }
}
.success {
  color: #01c944;
}
.fail {
  color: #ff0000;
}
</style>
